function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Common from '@/components/user/accessCommon';
import { assessPlanGetApi, assessPlanPutApi } from '@/api/enterprise';
export default {
  name: 'Plan',
  components: {
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    },
    selectDepartment: function selectDepartment() {
      return import('@/components/form-common/select-department');
    },
    assessBox: function assessBox() {
      return import('./assessBox');
    }
  },
  data: function data() {
    return {
      periodOptions: Common.periodOptions,
      planIndex: '2',
      from: {
        make: 'before',
        eval: 'before',
        verify: '',
        status: 0,
        remindDays: 1,
        remindMonth: 1,
        resource: '0'
      },
      months: 12,
      days: {
        makeDays: 3,
        evalDays: 3,
        verifyDays: 3
      },
      afterMaxDay: 3650,
      makeOptions: [{
        value: 'start',
        label: '考核开始后'
      }, {
        value: 'before',
        label: '考核结束前'
      }, {
        value: 'after',
        label: '考核结束后'
      }],
      evalOptions: [{
        value: 'start',
        label: '考核开始后'
      }, {
        value: 'before',
        label: '考核结束前'
      }, {
        value: 'after',
        label: '考核结束后'
      }],
      remindDaysData: [{
        value: 1,
        label: '星期一'
      }, {
        value: 2,
        label: '星期二'
      }, {
        value: 3,
        label: '星期三'
      }, {
        value: 4,
        label: '星期四'
      }, {
        value: 5,
        label: '星期五'
      }, {
        value: 6,
        label: '星期六'
      }, {
        value: 7,
        label: '星期七'
      }],
      departmentObj: {
        userList: [],
        // 选择成员
        frames: []
      },
      heightInputRole: 36,
      id: null,
      loading: false
    };
  },
  created: function created() {
    this.getTableData();
  },
  methods: {
    getTableData: function getTableData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result, data, list;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return assessPlanGetApi(_this.planIndex);
            case 2:
              result = _context.sent;
              data = result.data;
              _this.from.status = data.status;
              _this.from.make = data.make_type;
              _this.days.makeDays = data.make_day;
              _this.from.eval = data.eval_type;
              _this.days.evalDays = data.eval_day;
              _this.days.verifyDays = data.verify_day;
              _this.id = data.id;
              _this.from.resource = String(data.assess_type);
              _this.from.remindDays = data.create_time;
              _this.from.remindMonth = data.create_month;
              if (data.assess_type === 1) {
                _this.departmentObj.frames = data.test_frame;
                _this.departmentObj.userList = [];
              } else {
                list = [];
                data.test.map(function (item) {
                  var card = {
                    value: item.id,
                    name: item.name,
                    avatar: item.avatar
                  };
                  list.push(card);
                });
                _this.departmentObj.userList = list;
                _this.departmentObj.frames = [];
              }
              _this.handleMake(_this.from.make);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleClick: function handleClick(number) {
      this.planIndex = number.name;
      if (this.planIndex == 3) {
        this.months = 12;
      } else if (this.planIndex == 4) {
        this.months = 6;
      } else if (this.planIndex == 5) {
        this.months = 3;
      } else {
        this.months = 12;
      }
      this.getTableData();
    },
    handleMake: function handleMake(e) {
      if (e === 'after') {
        if (this.planIndex == 1) {
          this.afterMaxDay = 7;
        } else if (this.planIndex == 2) {
          this.afterMaxDay = 28;
        } else if (this.planIndex == 3) {
          this.afterMaxDay = 365;
        } else if (this.planIndex == 4) {
          this.afterMaxDay = 180;
        } else if (this.planIndex == 5) {
          this.afterMaxDay = 90;
        }
      } else {
        this.afterMaxDay = 3650;
      }
    },
    // 选择部门弹窗
    changeMastart: function changeMastart(data) {
      if (data.length > 0) {
        this.departmentObj.frames = data;
      } else {
        this.departmentObj.frames = [];
      }
    },
    // 选择成员弹窗
    getSelectList: function getSelectList(data) {
      this.departmentObj.userList = data;
    },
    handlePreserve: function handlePreserve(type) {
      var _this2 = this;
      if (this.from.name == '') {
        this.$message.error(this.$t('access.tips06'));
      } else if (this.days.makeDays == '') {
        this.$message.error(this.$t('access.tips07'));
      } else if (this.days.evalDays == '') {
        this.$message.error(this.$t('access.tips08'));
      } else if (this.days.verifyDays == '') {
        this.$message.error(this.$t('access.tips09'));
      } else if (this.days.makeDays > this.afterMaxDay) {
        this.days.makeDays = this.afterMaxDay;
        this.$message.error('目标制定时间超过了最大天数');
      } else {
        var check = [];
        var frame = [];
        if (this.from.resource == 0) {
          if (this.departmentObj.userList.length > 0) {
            this.departmentObj.userList.forEach(function (item) {
              check.push(item.value);
            });
          }
        } else {
          if (this.departmentObj.frames.length > 0) {
            this.departmentObj.frames.forEach(function (value) {
              frame.push(value.id);
            });
          }
        }
        var data = {
          make_type: this.from.make,
          make_day: this.days.makeDays,
          eval_type: this.from.eval,
          eval_day: this.days.evalDays,
          verify_day: this.days.verifyDays,
          status: this.from.status,
          assess_type: this.from.resource,
          create_time: this.from.remindDays,
          create_month: this.from.remindMonth
        };
        if (this.from.resource == 0) {
          data.test = check;
        } else {
          data.test_frame = frame;
        }
        this.loading = true;
        assessPlanPutApi(this.id, data).then(function (res) {
          if (res.status == 200) {
            _this2.loading = false;
            if (type !== 1) {
              _this2.$refs.assessBox.id = _this2.id;
              _this2.$refs.assessBox.openBox();
            }
          }
        }).catch(function (error) {
          _this2.loading = false;
        });
      }
    },
    cardTag: function cardTag(type, index) {
      type == 1 ? this.departmentObj.userList.splice(index, 1) : this.departmentObj.frames.splice(index, 1);
    }
  }
};